import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getChartOfAccounts } from '../../../../actions/index';
import Select from './Select';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../input/InputPropTypes';
import { optionsPropTypes } from './SelectPropTypes';

const ChartOfAccountSelect = ({
  options,
  loading,
  noOptionsMessage,
  input,
  meta,
  isDisabled,
  isClearable,
  isMulti,
  dispatchGetChartOfAccounts,
  hasContent,
}) => {
  useEffect(() => {
    if (!hasContent) {
      dispatchGetChartOfAccounts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSelectedOption = () => {
    if (!input.value) return null;
    if (typeof input.value === 'object') return input.value;
    return options.find(opt => opt.value === input.value) || null;
  };

  const customInput = {
    ...input,
    value: getSelectedOption(),
  };

  const props = {
    options,
    isLoading: loading,
    noOptionsMessage,
    input: customInput,
    meta,
    isDisabled,
    isClearable,
    isMulti,
  };

  return <Select {...props} />;
};

const mapStateToProps = ({ AccountingUnit }) => {
  const content = AccountingUnit.ChartOfAccount.getIn(['all', 'content']);

  return {
    options: content.map((account) => ({
      value: account.get('Code'),
      label: `${account.get('FormatCode')} - ${account.get('Name')}`,
    })),
    loading: AccountingUnit.ChartOfAccount.getIn(['all', 'loading']),
    hasContent: content.size > 0,
  };
};

ChartOfAccountSelect.propTypes = {
  options: optionsPropTypes,
  loading: PropTypes.bool.isRequired,
  noOptionsMessage: PropTypes.func,
  dispatchGetChartOfAccounts: PropTypes.func.isRequired,
  input: inputPropTypes,
  meta: metaPropTypes,
  isDisabled: PropTypes.bool,
  isClearable: PropTypes.bool,
  isMulti: PropTypes.bool,
  hasContent: PropTypes.bool.isRequired,
};

ChartOfAccountSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  noOptionsMessage: undefined,
  isDisabled: false,
  isClearable: true,
  isMulti: false,
  options: [],
};

const mapDispatchToProps = {
  dispatchGetChartOfAccounts: getChartOfAccounts,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChartOfAccountSelect);